import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-sm-25 p-lg-30 letter-spacing" }
const _hoisted_3 = { class: "mb-15 d-flex align-items-center justify-content-between" }
const _hoisted_4 = { class: "card-title fw-bold mb-0" }
const _hoisted_5 = {
  id: "projectDistributionChart",
  class: "chart"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h5", _hoisted_4, _toDisplayString(_ctx.nom), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_apexchart, {
          type: "donut",
          height: "382",
          options: _ctx.projectDistributionChart,
          series: _ctx.projects
        }, null, 8, ["options", "series"])
      ])
    ])
  ]))
}